import $ from 'jquery';

export default function swapNavTab() {
    var $kentico = $('.kenticoNav'),
        $shopTab = $('.shopTabLive');

    if ($shopTab.length) {
        $kentico.show();
        $('.selectedPrimary').removeClass();
        $('.hfShop')
            .parents('li')
            .addClass('selectedPrimary currentPageItem');
    }
}